import { HttpContextToken, HttpRequest } from '@angular/common/http';


/**
 * Http Context Token for Session HTTP Abort Scope
 * @public
 * @static
 * @returns {HttpContextToken<string>} Http Context Token for Session Abort Scope
 * @description Http Context Token for Session HTTP Abort Scope
 * @example
 * ```typescript
 * const sessionHttpAbortScopeContext = new HttpContextToken<string>(() => 'scope');
 * ```
 */
export const SESSION_ABORT_SCOPE_CONTEXT = new HttpContextToken<string>(() => 'scope');

/**
 * Http Context Token for Session Abort Global
 * @public
 * @static
 * @returns {HttpContextToken<boolean>} Http Context Token for Session Abort Global
 * @description Http Context Token for Session Abort Global
 * @example
 * ```typescript
 * const sessionAbortGlobalContext = new HttpContextToken<boolean>(() => false);
 * ```
 */
export const SESSION_ABORT_GLOBAL_CONTEXT = new HttpContextToken<boolean>(() => false);

/**
 * Http Context Token for Session Abort Matcher
 * @public
 * @static
 * @returns {HttpContextToken<((req: HttpRequest<unknown>) => boolean) | null>} Http Context Token for Session Abort Matcher
 * @description Http Context Token for Session Abort Matcher
 * @example
 * ```typescript
 * const sessionAbortMatcherContext = new HttpContextToken<((req: HttpRequest<unknown>) => boolean) | null>(() => null);
 * ```
 */
export const SESSION_ABORT_MATCHER_CONTEXT = new HttpContextToken<((req: HttpRequest<unknown>) => boolean) | null>(() => null);

/**
 * Http Context Token for Bypass Session HTTP Abort
 * @public
 * @static
 * @returns {HttpContextToken<boolean>} Http Context Token for Bypass Session Abort
 * @description Http Context Token for Bypass Session Abort
 * @example
 * ```typescript
 * const bypassSessionAbortContext = new HttpContextToken<boolean>(() => false);
 * ```
 */
export const BYPASS_SESSION_ABORT_CONTEXT = new HttpContextToken<boolean>(() => false);